import { type CAPITAL_PARTNER_NETWORK_CONTENT } from '../content';
import {
  CardStack,
  ContentContainer,
  HighlightNote,
  Section,
  SectionEyebrow,
  SectionIntro,
  SectionParagraph,
  SectionTitle,
  SplitGrid,
  SurfaceCard,
  SurfaceEyebrow,
  SurfaceText,
  SurfaceTitle,
} from '../styles';

type NetworkDefinitionCopy = (typeof CAPITAL_PARTNER_NETWORK_CONTENT)['networkDefinition'];

type NetworkDefinitionSectionProps = {
  copy: NetworkDefinitionCopy;
};

export default function NetworkDefinitionSection({
  copy,
}: NetworkDefinitionSectionProps) {
  return (
    <Section>
      <ContentContainer>
        <SplitGrid>
          <SectionIntro>
            <SectionEyebrow>{copy.eyebrow}</SectionEyebrow>
            <SectionTitle>{copy.title}</SectionTitle>
          </SectionIntro>
          <CardStack>
            <SurfaceCard>
              <SectionParagraph>{copy.paragraphs[0]}</SectionParagraph>
              <SurfaceText>{copy.paragraphs[1]}</SurfaceText>
            </SurfaceCard>
            <SurfaceCard>
              <SurfaceEyebrow>Important nuance</SurfaceEyebrow>
              <SurfaceTitle>Selective by design.</SurfaceTitle>
              <HighlightNote>{copy.note}</HighlightNote>
            </SurfaceCard>
          </CardStack>
        </SplitGrid>
      </ContentContainer>
    </Section>
  );
}
